import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const AcceptTCModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=Uukq8_QqWmw&ab_channel=apadua" />
);

export default AcceptTCModal;
